import { useState, useEffect, useCallback } from 'react';
import './Games.css';

export default function ShootingStarGame({ theme = 'default' }) {
    const [score, setScore] = useState(0);
    const [stars, setStars] = useState([]);

    const createStar = useCallback(() => {
        const newStar = {
            id: Date.now() + Math.random(),
            left: Math.random() * 85,
            duration: 2.5 + Math.random() * 1.5,
            emoji: ['⭐', '🌟', '✨', '💫'][Math.floor(Math.random() * 4)]
        };
        setStars(prev => [...prev, newStar]);

        setTimeout(() => {
            setStars(prev => prev.filter(s => s.id !== newStar.id));
        }, newStar.duration * 1000);
    }, []);

    useEffect(() => {
        const interval = setInterval(createStar, 700);
        return () => clearInterval(interval);
    }, [createStar]);

    const catchStar = (e, id) => {
        e.preventDefault();
        e.stopPropagation();
        setStars(prev => prev.filter(s => s.id !== id));
        setScore(prev => prev + 10);
    };

    const themeClass = theme === 'daetong' ? 'theme-daetong' : theme === 'lighthouse' ? 'theme-lighthouse' : '';

    return (
        <div className={`game-container shooting-star-game ${themeClass}`}>
            <div className="game-title">⭐ 별똥별을 터치하세요!</div>
            <div className="game-area">
                <div className="game-score">점수: {score}</div>
                {stars.map(star => (
                    <div
                        key={star.id}
                        className="star"
                        style={{
                            left: `${star.left}%`,
                            animation: `star-fall ${star.duration}s linear forwards`
                        }}
                        onClick={(e) => catchStar(e, star.id)}
                        onTouchEnd={(e) => catchStar(e, star.id)}
                    >
                        {star.emoji}
                    </div>
                ))}
            </div>
        </div>
    );
}
